import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'emergency_alarm_system_buttons_switches_pull_stations_are'

export const dataPointDefinition = {
  retracedId: 'emergency_alarm_system_buttons_switches_pull_stations_are',
  name: 'Emergency alarm system buttons/switches/pull stations are not easily identified and accessible',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-eme-16x',
      number: 'HS-EME-7-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-eme-12',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-eme-2;hs-eme-8,Yes',
      machineShowHide: '[2],hs-eme-2;hs-eme-8,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-16x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30630,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
